import React, { useState } from 'react';
import './CreateSeasonModal.css';

function OptOutReasonModal({ participant, onClose, onSave }) {
  const [reason, setReason] = useState('');
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!reason || reason.trim().length === 0) {
      setError('Reason is required');
      return;
    }

    if (reason.trim().length < 10) {
      setError('Reason must be at least 10 characters');
      return;
    }

    setSaving(true);
    setError(null);

    try {
      await onSave(reason.trim());
    } catch (err) {
      console.error('Save error:', err);
      setError(err.response?.data?.error || 'Failed to opt out participant');
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Opt Out Participant</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {error && (
              <div className="error-message">{error}</div>
            )}

            <div style={{ marginBottom: '1.5rem', padding: '1rem', background: '#f8f9fa', borderRadius: '4px' }}>
              <p style={{ margin: 0, color: '#666' }}>
                <strong style={{ color: 'var(--primary-color)' }}>{participant?.username}</strong>
                {participant?.display_name && ` (${participant.display_name})`}
              </p>
            </div>

            <div className="form-group">
              <label htmlFor="reason">Reason for Opting Out *</label>
              <textarea
                id="reason"
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value);
                  if (error) setError(null);
                }}
                placeholder="Enter the reason for opting out this participant (e.g., 'User requested to be removed', 'Inactive', etc.)"
                disabled={saving}
                className={error ? 'error' : ''}
                rows="5"
              />
              {error && <span className="field-error">{error}</span>}
            </div>

            <p className="form-note">
              This will set is_active = false and record the opt-out date and reason.
              The participant can be re-activated later if needed.
            </p>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              onClick={onClose}
              className="btn btn-cancel"
              disabled={saving}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={saving}
            >
              {saving ? 'Opting Out...' : 'Opt Out'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default OptOutReasonModal;
